import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_VIEW: MijnRoute = {
    path: ':id',
    navigationEvent: 'toBeleggen',
    regex: /^\/beleggen\/[^/]+$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent'
};
